(function(){
  // Panel width is READ FROM CSS (--tlc-xpanel-w) rather than duplicated here, so narrowing the
  // panel is a one-line CSS change and the space test follows automatically.
  // FLOOR lowered to 820 with the narrower panel (founder: "open it on smaller screens too").
  // At 820 the drawer leaves ~372px to its left and the panel needs 300 + 16, so it still clears
  // with room rather than pinning itself to the viewport edge. Below that it stays inline.
  function panelWidth(){
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--tlc-xpanel-w'), 10);
    return isFinite(v) && v > 0 ? v : 300;
  }
  var GAP = 16, FLOOR = 820;
  var host = null, home = null, node = null;

  // Founder 2026-08-21: a fixed 1100px breakpoint was wrong. Their browser window is not
  // maximised, so the viewport sat under it and the panel silently stayed inline inside the
  // drawer - which reads as "it still does not open". What actually matters is not the viewport
  // width but whether there is room to the LEFT of the drawer for the panel. So the test is
  // measured space, not a magic number: show it when the gap between the viewport edge and the
  // drawer can hold the panel. FLOOR keeps it off phones and small tablets regardless.
  // The drawer's left edge, or null when the measurement cannot be trusted yet.
  // It cannot be trusted in two situations, both seen live: mid open-animation, and while the
  // drawer is closed - in the closed state this drawer keeps a layout box that can sit right of
  // the viewport edge. Reading it blindly produced a negative offset, which clamped to 0 and put
  // the panel ON TOP of the cart. So an out-of-range reading returns null and the caller retries
  // on the next frame instead of positioning against a bogus number.
  // Measured position first, with a FALLBACK so the panel can never be lost to a measurement
  // that will not settle. That fallback matters: an earlier build gated purely on
  // innerWidth >= 1100 and the founder confirmed the panel opening correctly; switching to a
  // purely measured gate then made it refuse whenever the rect stayed unusable. So: trust the
  // measurement when it is sane, otherwise fall back to the drawer's known width on any viewport
  // wide enough to hold both. The post-layout overlap guard in put() still runs either way, so a
  // wrong fallback hides the panel rather than covering the cart.
  var DRAWER_W = 448, WIDE = 820;
  function drawerLeft(){
    var col = drawerCol();
    if (col){
      var l = col.getBoundingClientRect().left;
      if (isFinite(l) && l >= 0 && l <= window.innerWidth - 40) return l;
    }
    if (window.innerWidth >= WIDE) return window.innerWidth - DRAWER_W;
    return null;
  }
  function hasRoom(){
    if (window.innerWidth < FLOOR) return false;
    var l = drawerLeft();
    return l !== null && l >= (panelWidth() + GAP);
  }

  function panel(){ return document.querySelector('.cart-drawer__cross-sell'); }
  // Which element actually paints the drawer depends on which cart build is on: cart_v2 renders
  // .tcv2, the v1 path renders .v-stack.gap-5. At 1440 both report the same rect so either works;
  // at 1000 they diverge and .v-stack.gap-5 reports a box sitting off the right edge, which is how
  // the panel ended up positioned over the cart. So: try every candidate and take the first with a
  // sane, on-screen rect rather than trusting one selector.
  function drawerCol(){
    var d = document.getElementById('cart-drawer');
    if (!d) return null;
    var cands = [].slice.call(d.querySelectorAll('.tcv2, .v-stack.gap-5'));
    if (d.firstElementChild) cands.push(d.firstElementChild);
    for (var i = 0; i < cands.length; i++){
      var r = cands[i].getBoundingClientRect();
      if (r.width > 200 && r.left >= 0 && r.left <= window.innerWidth - 40) return cands[i];
    }
    return null;
  }
  function ensureHost(){
    if (host && document.body.contains(host)) return host;
    host = document.createElement('div');
    host.className = 'tlc-xpanel-host';
    host.hidden = true;
    document.body.appendChild(host);
    return host;
  }
  // The drawer animates open and the recommendations hydrate asynchronously, so the first few
  // reads of the drawer's position are unusable. A 30-frame (~0.5s) retry was not enough: the
  // panel gave up while the drawer was still sliding in and never appeared even though the
  // drawer was open. This polls every 120ms for up to 4s instead, and only while the drawer is
  // actually open, so it costs nothing when the cart is closed.
  var deadline = 0, pollTimer = null;
  function put(){
    var p = panel(), l = drawerLeft();
    if (!p) return;
    if (l === null){
      if (!deadline) deadline = Date.now() + 4000;
      if (Date.now() < deadline && drawerOpen()){
        clearTimeout(pollTimer);
        pollTimer = setTimeout(put, 120);
      }
      return;
    }
    deadline = 0; clearTimeout(pollTimer);
    if (!hasRoom()) { restore(); return; }
    var h = ensureHost();
    if (p.parentElement !== h){
      node = p; home = p.parentElement;
      h.appendChild(p);
    }
    document.documentElement.style.setProperty('--tlc-xpanel-right', Math.round(window.innerWidth - l) + 'px');
    h.hidden = false;
    // Never overlap the cart. If the panel's right edge is not resting on the drawer's left edge
    // after layout, the offset was wrong - hide rather than cover the line items and the total.
    requestAnimationFrame(function(){
      if (!h || h.hidden) return;
      var hr = h.getBoundingClientRect(), dl = drawerLeft();
      if (dl === null || hr.right > dl + 2 || hr.left < 0) { restore(); }
    });
  }
  function restore(){
    deadline = 0; clearTimeout(pollTimer);
    if (host) host.hidden = true;
    if (node && home && node.parentElement !== home){ home.appendChild(node); }
  }
  function drawerOpen(){
    // The [open] attribute is the ONLY reliable signal here. A geometry fallback was tried and
    // removed: when this drawer closes it keeps its layout box exactly where it was - the content
    // column still measures 416px wide at the same on-screen left edge - so a rect test reports
    // "open" forever and the panel never goes away. Verified both states: open -> [open] present
    // and :modal true; closed -> attribute gone, scrim faded to opacity 0.
    var d = document.getElementById('cart-drawer');
    return !!(d && d.hasAttribute('open'));
  }
  function sync(){
    if (!drawerOpen() || !hasRoom()) { restore(); return; }
    put();
  }

  var t;
  function schedule(){ clearTimeout(t); t = setTimeout(sync, 60); }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('resize', schedule);
  // the drawer and the recommendations both hydrate asynchronously, so watch for both
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['open','hidden','class']
  });
  schedule();
})();
